export default __webpack_public_path__ + "static/media/castejon.7fa928f7.jpg";